import React from "react";
import AffiliateCTA from "./AffiliateCTA";
import RecommendationForm from "./RecommendationForm";
import ProviderInterestForm from "./ProviderInterestForm";

// Reusable monetization stack: affiliate CTA band + two DB-backed lead forms.
// Newsletter is rendered separately by each page (also a monetization block).
export const MonetizationBlocks = ({ browseTo, recommendationStyle = "" }) => (
  <>
    <AffiliateCTA browseTo={browseTo} />
    <section data-testid="monetization-forms" className="bg-brand-bg">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-6 px-6 py-20 md:grid-cols-2 md:px-10 md:py-24">
        <RecommendationForm defaultStyle={recommendationStyle} />
        <ProviderInterestForm />
      </div>
    </section>
  </>
);

export default MonetizationBlocks;
